import React from 'react';
import './LandingPage.css';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Bumpups from './components/Bumpups';
import Timestamp from './components/timestampcomp/Timestamp';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <NavBar />

      <main className="landing-main">
        <section className="hero" id="about">
          <div className="hero-copy">
            <span className="hero-badge">Creator intelligence platform</span>
            <h1 className="main-title">Stamp Sage is the operating system for video-first teams</h1>
            <p className="subtitle">
              Bring AI timestamps, time tracking, collaboration, and growth insights into one workspace. From the first
              idea to the final upload, Stamp Sage keeps every creator in flow and every release on tempo.
            </p>

            <div className="hero-actions">
              <button type="button" className="btn btn-primary">Start generating timestamps</button>
              <button type="button" className="btn btn-secondary">Explore the suite</button>
            </div>

          </div>
      
        </section>

        <Timestamp />
        <Bumpups />
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
